import React from "react";
import { Home } from "../../components/home/home.component";

export const HomePage = () => {
  return <Home />;
};
